import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { isMobile, isNotMobile } from './actions';

export const layoutFeatureKey = "layout"

export interface State {
  isMobile: boolean;
}

const initialState: State = {
  isMobile: false,
};

export const reducer = createReducer(
  initialState,
  on(isMobile, (): State => ({ isMobile: true })),
  on(isNotMobile, (): State => ({ isMobile: false }))
);


export const selectLayoutState = createFeatureSelector<State>(layoutFeatureKey);


export const selectViewportState = createSelector(
  selectLayoutState,
  (state: any) => state.isMobile
);
